import PolicyDetailsList from './PolicyDetailsList';

export default PolicyDetailsList;
